import { render, staticRenderFns } from "./AppReviewOverlayInfoVertical.vue?vue&type=template&id=216ddb57&scoped=true"
import script from "./AppReviewOverlayInfoVertical.vue?vue&type=script&lang=js"
export * from "./AppReviewOverlayInfoVertical.vue?vue&type=script&lang=js"
import style0 from "./AppReviewOverlayInfoVertical.vue?vue&type=style&index=0&id=216ddb57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ddb57",
  null
  
)

export default component.exports